import { Toolbar as BaseToolbar } from "@base-ui/react/toolbar";
import type React from "react";
import { forwardRef } from "react";
import {
  toolbarButtonClass,
  toolbarRootClass,
  toolbarSeparatorClass,
} from "./styles.css";

export type ToolbarOrientation = "horizontal" | "vertical";

interface ToolbarRootProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: ToolbarOrientation;
  disabled?: boolean;
  loopFocus?: boolean;
}

const ToolbarRoot = forwardRef<HTMLDivElement, ToolbarRootProps>(
  function ToolbarRoot(
    {
      orientation = "horizontal",
      disabled,
      loopFocus = true,
      children,
      className,
      ...props
    },
    ref,
  ) {
    return (
      <BaseToolbar.Root
        ref={ref}
        orientation={orientation}
        disabled={disabled}
        loopFocus={loopFocus}
        className={`${toolbarRootClass}${className ? ` ${className}` : ""}`}
        {...props}
      >
        {children}
      </BaseToolbar.Root>
    );
  },
);

interface ToolbarButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  disabled?: boolean;
}

const ToolbarButton = forwardRef<HTMLButtonElement, ToolbarButtonProps>(
  function ToolbarButton({ children, className, disabled, ...props }, ref) {
    return (
      <BaseToolbar.Button
        ref={ref}
        disabled={disabled}
        className={`${toolbarButtonClass}${className ? ` ${className}` : ""}`}
        {...props}
      >
        {children}
      </BaseToolbar.Button>
    );
  },
);

interface ToolbarSeparatorProps extends React.HTMLAttributes<HTMLDivElement> {}

const ToolbarSeparator = forwardRef<HTMLDivElement, ToolbarSeparatorProps>(
  function ToolbarSeparator({ className, ...props }, ref) {
    return (
      <BaseToolbar.Separator
        ref={ref}
        className={`${toolbarSeparatorClass}${className ? ` ${className}` : ""}`}
        {...props}
      />
    );
  },
);

const ToolbarComponent = Object.assign(ToolbarRoot, {
  Button: ToolbarButton,
  Separator: ToolbarSeparator,
});

export { ToolbarComponent as Toolbar };

ToolbarRoot.displayName = "ToolbarRoot";

ToolbarButton.displayName = "ToolbarButton";

ToolbarSeparator.displayName = "ToolbarSeparator";
